<script lang="ts">
    import type {Field} from 'node_modules/svelte-forms/types';
    import type {FormController} from '../../forms/types';
    import {onMount} from 'svelte';
    import type {Observable} from 'rxjs';
    import type {CustomValueEditorLocalizations, ValueEditorTypeOrAlias} from '../../../types';
    import type {ValueEditorSize} from '../../../types';
    import type {ValueEditorOptions, ValueEditorValidations} from '../../../kp-value-editor/types';
    import type {ValueEditorLocalizations} from '../../../localizations/types';
    import KpValueEditor from '../../../kp-value-editor/KpValueEditor.svelte';
    import {createValueEditorsLabelContext, setValueEditorLabelContext} from '../../label/value-editor-label-context';
    import ValueEditorLabel from '../../label/ValueEditorLabel.svelte';
    import type {FormControlOptions} from '../../forms/types';
    import type {EditorsLocalizationFunction} from '../../../localizations/types';
    import type {ListValueEditorLocalizations} from './types';
    import {getContext} from 'svelte';
    import {EDITORS_LOCALIZE} from '../../../context-keys';

    type MODEL_VALUE = $$Generic;

    export let model: MODEL_VALUE;
    export let formControlOptions: FormControlOptions;

    export let orderNumber: number;

    export let type: ValueEditorTypeOrAlias;

    export let editorId: string;
    export let editorName: string;
    export let placeholder: string;

    export let isDisabled = false;
    export let isVisible = true;
    export let isFocused = false;
    export let size: ValueEditorSize;

    export let options: ValueEditorOptions;
    export let validations: ValueEditorValidations;
    export let localizations: CustomValueEditorLocalizations<ValueEditorLocalizations>;

    export let forceShowErrors: boolean;

    const localize: EditorsLocalizationFunction<ListValueEditorLocalizations> = getContext(EDITORS_LOCALIZE);

    let editorController;
    let formField$: Observable<Field<MODEL_VALUE>>;
    let isTouched$: Observable<boolean>;


    onMount(() => {
        const formControl = getFormController();
        formField$ = formControl.getFieldState$();
        isTouched$ = formControl.isTouched$();
    })

    setValueEditorLabelContext(createValueEditorsLabelContext(editorId));

    function showValidationError(fieldState: Field<MODEL_VALUE>, show: boolean): boolean {
        if (fieldState) {
            return fieldState.invalid && show;
        }
        return false;
    }

    export function getFormController(): FormController<MODEL_VALUE> {
        return editorController.getFormController();
    }
</script>

<template>
    <!-- invisible index label for screen readers -->
    <ValueEditorLabel fieldRequired={validations?.required} additionalClasses="sr-only">
        {localize('item')} {orderNumber}
    </ValueEditorLabel>
    <div class="list-item-content"
         class:has-error={showValidationError($formField$, $isTouched$ || forceShowErrors)}
         class:has-not-error={!showValidationError($formField$, $isTouched$ || forceShowErrors)}>

        <KpValueEditor bind:this={editorController}

                       {type}

                       bind:model
                       {formControlOptions}

                       {editorId}
                       {editorName}

                       {placeholder}


                       {isVisible}
                       {isDisabled}
                       {isFocused}
                       {forceShowErrors}
                       {size}

                       {options}
                       {validations}
                       {localizations}

                       on:form-submit-request
                       on:form-structure-change/>

    </div>
</template>

<style lang="less">
    .list-item-content {
        flex-grow: 1;
        position: relative;
    }
</style>